import React from "react"

const Product = props => {
    return (
        <div className="bodyContainer">Product Page is under development.</div>
    )
}

export default Product
